export enum ETipoDataTituloFinanceiro {
    DataCriacao = 1,
    DataVencimento = 2,
    DataCompetencia = 3,
    DataBaixa = 4,
}
